import { render, staticRenderFns } from "./folderDetails.vue?vue&type=template&id=cf0b6880&scoped=true"
import script from "./folderDetails.vue?vue&type=script&lang=js"
export * from "./folderDetails.vue?vue&type=script&lang=js"
import style0 from "./folderDetails.vue?vue&type=style&index=0&id=cf0b6880&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0b6880",
  null
  
)

export default component.exports